module.exports = __webpack_public_path__ + "img/tando.3da7f0c.png";